module.exports = __webpack_public_path__ + "static/media/validate_arrow_default.efb47114.svg";